module.exports = __webpack_public_path__ + "images/09-01@2x_98a4f02b.png";